import { useEffect } from "react";
import { Link } from "react-router-dom";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";
import "./Legal.css";

function LegalPage({ title, updated, children, alternate }) {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${title} — The Way 5:23`;
    return () => {
      document.title =
        "The Way 5:23 — Steward Your Spirit, Soul, and Body";
    };
  }, [title]);

  return (
    <div className="page">
      <SiteHeader />
      <main className="legal">
        <div className="container legal-inner">
          <p className="overline">Legal</p>
          <h1 className="legal-title">{title}</h1>
          <p className="legal-updated">Last Updated: {updated}</p>

          <div className="legal-body">{children}</div>

          {alternate && (
            <p className="legal-alternate">
              Also see our{" "}
              <Link to={alternate.to}>{alternate.label}</Link>.
            </p>
          )}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}

export default LegalPage;
